module.exports = __webpack_public_path__ + "img/logo.dfa0a83f.png";